import pdfThumbnail from '../../assets/img/pdf.png';
import pptxThumbnail from '../../assets/img/pptx.png';
import docxThumbnail from '../../assets/img/docx.png';
import xlsxThumbnail from '../../assets/img/xlsx.png';
import genericThumbnail from '../../assets/img/generic.png';

export const AGENT_AVAILABILITY_STATES = {
  ONLINE: 'ONLINE',
  BACK_SOON: 'BACK_SOON',
  AWAY: 'AWAY',
  OFFLINE: 'OFFLINE',
};

export const PAGE_VIEW_MODES = {
  FULL_TABLE: 'full-table',
  PARTIAL_TABLE: 'partial-table',
  CONVERSATIONAL: 'conversational',
  TILES: 'tiles',
};

export const TABS = {
  AGENT_LIST: 'agent-list',
  ALL_CONNECTIONS: 'all-connections',
  MY_CONNECTIONS: 'my-connections',
  ALL_TASKS: 'all-tasks',
};

export const CONVERSATION_STATUSES = {
  OVERDUE: 'overdue',
  ONGOING: 'ongoing',
  IDLE: 'idle',
  CLOSE: 'close',
  IN_QUEUE: 'inqueue',
};

export const ALL_CONNECTIONS_CONVERSATION_STATUSES = {
  CLOSE: 'close',
  OPEN: 'open',
  OVERDUE: 'overdue',
  IN_QUEUE: 'inqueue',
};

export const CUSTOM_WIDGET_NOTIFICATION_STATUSES = {
  READ: 'READ',
  UNREAD: 'UNREAD',
};

export const CUSTOM_WIDGET_NOTIFICATION_COMANDS = {
  ADD: 'ADD',
  DELETE: 'DELETE',
  CLEAR: 'CLEAR',
};

export const EX_CONVERSATION_NOTIFICATION_TYPES = {
  UPSERT: 'UPSERT',
  DELETE: 'DELETE',
};

export const RING_STATES = {
  ACCEPTED: 'ACCEPTED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  REJECTED: 'REJECTED',
  WAITING: 'WAITING',
  ALREADY_ACCEPTED: 'ALREADY_ACCEPTED',
};

export const RING_QUEUE_STATES = {
  ACCEPTING: 'ACCEPTING',
  ACCEPT_SENT: 'ACCEPT_SENT',
  IDLE: 'IDLE',
  BLOCKED: 'BLOCKED',
};

export const RING_QUEUE_MODE = {
  AUTO_ACCEPT: 'AUTO_ACCEPT',
  MANUAL: 'MANUAL_ACCEPT',
};

export const MOMENT_LANGUAGE = {
  'da-DK': 'da', // Danish
  'de-DE': 'de', // German
  'en-US': 'en', // English
  'es-ES': 'es', // Spanish
  'fi-FI': 'fi', // Finnish
  'fr-FR': 'fr', // French
  'it-IT': 'it', // Italian
  'ja-JP': 'ja', // Japanese
  'ko-KR': 'ko', // Korean
  'pt-BR': 'pt-br', // Portuguese (Brazil)
  'ro-RO': 'ro', // Romanian,
  'ru-RU': 'ru', // Russian
  'tr-TR': 'tr', // Turkish
  'zh-CN': 'zh-cn', // Chinese (PRC)
};

export const DIALOG_TYPES = {
  MAIN: 'MAIN',
  POST_SURVEY: 'POST_SURVEY',
  AGENT: 'AGENT',
  OTHER: 'OTHER',
};

export const DIALOG_STATES = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
};

export const DIALOG_CHANNEL_TYPES = {
  COBROWSE: 'COBROWSE',
};

export const CONVERSATION_WINDOW_ACTIONS = {
  CLOSE_CONVERSATION: 'closeConversation',
  RESPOND_NEXT_CONVERSATION: 'respondNextConversation',
  RETURN_TO_QUEUE: 'returnToQueue',
  TRANSFER_TO_SKILL: 'transferToSkill',
  TRANSFER_TO_AGENT: 'transferToAgent',
  COPY_AS_PLAIN_TEXT: 'copyAsPlainText',
  LEAVE_CONVERSATION: 'leaveConversation',
  JOIN_CONVERSATION: 'joinConversation',
  TAKEOVER: 'takeover',
  UNSELECT_CONVERSATION: 'unselectConversation',
  PRIVATE_MESSAGES_SEND: 'privateMessagesSend',
};

export const TRANSFER_REASONS = {
  AGENT: 'Agent',
  SKILL: 'Skill',
};

export const EMPTY_FIRST_CONVERSATION_ID = null;
export const EMPTY_FOCUSED_CONVERSATION_ID = null;
export const EMPTY_CONSUMER_CONVERSATIONS_HISTORY = null;

export const NEW_NOTE_UNIQUE_ID = '-1';

export const MESSAGE_STATUSES = {
  LOADING: 'LOADING',
  SENT: 'SENT',
  ACCEPT: 'ACCEPT',
  READ: 'READ',
  VIEWED: 'VIEWED',
  ERROR: 'ERROR',
  NACK: 'NACK',
  COMMAND_ERROR: 'COMMAND_ERROR',
  COMMAND_SUCCESS: 'COMMAND_SUCCESS',
};

export const MESSAGE_STATUS_LEVELS = {
  [MESSAGE_STATUSES.LOADING]: -1,
  [MESSAGE_STATUSES.SENT]: 0,
  [MESSAGE_STATUSES.ACCEPT]: 1,
  [MESSAGE_STATUSES.READ]: 2,
  [MESSAGE_STATUSES.VIEWED]: 3,
  [MESSAGE_STATUSES.ERROR]: 4,
  [MESSAGE_STATUSES.NACK]: 5,
};

export const DEFAULT_CONVERSATION_STATUS_FILTER = [
  CONVERSATION_STATUSES.OVERDUE,
  CONVERSATION_STATUSES.ONGOING,
  CONVERSATION_STATUSES.IN_QUEUE,
  CONVERSATION_STATUSES.IDLE,
];

export const CONVERSATION_SOURCE_NAME = {
  WEB: 'WEB',
  LINE: 'LINE',
  GOOGLE: 'GOOGLE',
  WHC: 'WHC',
  PLUSMESSAGE: 'PLUSMESSAGE',
  BMRCS: 'BMRCS',
  SMS: 'SMS',
  APPLE: 'APPLE',
  APPLE_BUSINESS_CHAT: 'APPLE BUSINESS CHAT',
  FACEBOOK: 'FACEBOOK',
  TWITTER: 'TWITTER',
  INSTAGRAM: 'INSTAGRAM',
  GRBM: 'GRBM',
  WHATSAPP: 'WHATSAPP',
  RCS: 'RCS',
  WECHAT: 'WECHAT',
  CHROME: 'CHROME',
  FIREFOX: 'FIREFOX',
  SAFARI: 'SAFARI',
  EDGE: 'EDGE',
  MSIE: 'MSIE', // IE browser
  OPERA: 'OPERA',
  UNKNOWN: 'UNKNOWN',
  SHARK: 'SHARK',
  SHARK_C4M: 'SHARK-C4M',
  APP: 'APP',
  RCS_BUSINESS_MESSAGING: 'RCS BUSINESS MESSAGING',
  WE_CHAT: 'WECHAT',
  WHATSAPP_BUSINESS: 'WHATSAPP BUSINESS',
  VFRCS: 'vfrcs',
  INTEROPRCS: 'interOprcs',
  SUMMITRCS: 'summitrcs',
  CMCCRCS: 'cmccrcs',
  ATTRCS: 'attrcs',
  ORANGERCS: 'orangercs',
  VZWRCS: 'vzwrcs',
  EMAIL: 'Email',
  MOBILE_APP: 'mobile-app',
  MAVEN: 'Maven Messenger',
};

export const CONNECTOR_LIST = [
  CONVERSATION_SOURCE_NAME.SMS,
  CONVERSATION_SOURCE_NAME.APPLE,
  CONVERSATION_SOURCE_NAME.APPLE_BUSINESS_CHAT,
  CONVERSATION_SOURCE_NAME.GRBM,
  CONVERSATION_SOURCE_NAME.FACEBOOK,
  CONVERSATION_SOURCE_NAME.INSTAGRAM,
  CONVERSATION_SOURCE_NAME.WHATSAPP,
  CONVERSATION_SOURCE_NAME.GOOGLE,
  CONVERSATION_SOURCE_NAME.LINE,
  CONVERSATION_SOURCE_NAME.WE_CHAT,
];

export const CONSUMER_INFO_SECTIONS = {
  CONSUMER_INFO: 'consumerInfo',
  CONVERSATION_INFO: 'conversationInfo',
  CAMPAIGN_INFO: 'campaignInfo',
  PERSONAL_INFO: 'personalInfo',
  CUSTOMER_INFO: 'customerInfo',
  SERVICE_ACTIVITY: 'serviceActivity',
  SEARCH_CONTENT: 'searchContent',
  VISITOR_ERROR: 'visitorError',
  MARKETING_SOURCE: 'marketingSource',
  CART_STATUS: 'cartStatus',
  TRANSACTION: 'transaction',
  VIEWED_PRODUCT: 'viewedProduct',
  LEAD: 'lead',
  VEHICLE_OF_INTEREST: 'vehicleOfInterest',
  PAGE_VIEW: 'pageView',
};

export const SDES_TYPE = {
  MARKETING_CAMPAIGN_INFO: 'MARKETING_CAMPAIGN_INFO',
  CUSTOMER_INFO: 'CUSTOMER_INFO',
  PERSONAL_INFO: 'PERSONAL_INFO',
  CART_STATUS: 'CART_STATUS',
  VIEWED_PRODUCT: 'VIEWED_PRODUCT',
  PURCHASE: 'PURCHASE',
  LEAD: 'LEAD',
  SERVICE_ACTIVITY: 'SERVICE_ACTIVITY',
  VISITOR_ERROR: 'VISITOR_ERROR',
  SEARCH_CONTENT: 'SEARCH_CONTENT',
  VEHICLE_OF_INTEREST: 'VEHICLE_OF_INTEREST',
};

export const SEARCH_CONVERSATIONS_API_CONTENT_TO_RETRIVE = {
  CAMPAIGN: 'campaign',
  MESSAGE_RECORDS: 'messageRecords',
  AGENT_PARTICIPANTS: 'agentParticipants',
  AGENT_PARTICIPANTS_LEAVE: 'agentParticipantsLeave',
  AGENT_PARTICIPANTS_ACTIVE: 'agentParticipantsActive',
  CONSUMER_PARTICIPANTS: 'consumerParticipants',
  TRANSFERS: 'transfers',
  INTERACTIONS: 'interactions',
  MESSAGE_SCORES: 'messageScores',
  MESSAGE_STATUSES: 'messageStatuses',
  CONVERSATION_SURVEYS: 'conversationSurveys',
  SUMMARY: 'summary',
  SDES: 'sdes',
  UNAUTH_SDES: 'unAuthSdes',
  MONITORING: 'monitoring',
  RESPONSE_TIME: 'responseTime',
  INTENTS: 'intents',
  DIALOGS: 'dialogs',
  PREVIOUSLY_SUBMITTED_AGENT_SURVEYS: 'previouslySubmittedAgentSurveys',
  LATEST_AGENT_SURVEY: 'latestAgentSurvey',
  PAGE_VIEW: 'pageView',
};

export const PCS_CLOSE_REASON_TYPES = {
  IGNORED: {
    TYPE: 'Ignored',
    TRANSLATION_KEY: 'aw:myConnections_post_survey_expired',
  },
  COMPLETED: {
    TYPE: 'Completed',
    TRANSLATION_KEY: 'aw:myConnections_post_survey_completed',
  },
  PARTIALLY_COMPLETED_TIMED_OUT: {
    TYPE: 'Partially completed - timed out',
    TRANSLATION_KEY: 'aw:myConnections_post_survey_expired',
  },
  PARTIALLY_COMPLETED_SKIPPED: {
    TYPE: 'Partially completed - skipped',
    TRANSLATION_KEY: 'aw:myConnections_post_survey_expired',
  },
  SKIPPED: {
    TYPE: 'Skipped',
    TRANSLATION_KEY: 'aw:myConnections_post_survey_skipped',
  },
  CLOSED_BY_CONSUMER: {
    TYPE: 'Closed by consumer',
    TRANSLATION_KEY: 'aw:myConnections_post_survey_skipped',
  },
  CONSUMER_UNRECOGNIZED_ANSWER: {
    TYPE: 'Consumer unrecognized answer',
    TRANSLATION_KEY: 'aw:myConnections_post_survey_skipped',
  },
  NOT_SUPPORTED: {
    TYPE: 'Not Supported',
    TRANSLATION_KEY: '', // No message will be displayed
  },
  SYSTEM_PROTECTION: {
    TYPE: 'SYSTEM_PROTECTION',
    TRANSLATION_KEY: 'aw:myConnections_post_survey_expired',
  },
  BRAND_AUTO_CLOSE: {
    TYPE: 'BRAND_AUTO_CLOSE',
    TRANSLATION_KEY: 'aw:myConnections_post_survey_expired',
  },
  MANUAL_CLOSE: {
    TYPE: 'MANUAL_CLOSE',
    TRANSLATION_KEY: 'aw:myConnections_post_survey_expired',
  },
  ERROR_IN_SURVEY_FLOW: {
    TYPE: 'FlowConfigError',
    TRANSLATION_KEY: 'aw:myConnections_post_survey_closed',
  },
  NA: {
    TYPE: 'NA',
    TRANSLATION_KEY: 'aw:myConnections_post_survey_closed',
  },
};

export const CONVERSATION_PARTICIPANT_STATE = {
  COMPOSING: 'COMPOSING',
  ACTIVE: 'ACTIVE',
};

export const RESPONSE_TIME_FILTER_TYPES = {
  BETWEEN: 'between',
  FROM: 'from',
  UNTIL: 'until',
};

export const TIME_FILTER_UNITS = {
  SECONDS: 'seconds',
  MINUTES: 'minutes',
  HOURS: 'hours',
  DAYS: 'days',
};

export const RESPONSE_TIME_FILTER_UNITS = {
  MINUTES: 'minutes',
  HOURS: 'hours',
  DAYS: 'days',
};

export const RESPONSE_TIME_UNITS_TO_MOMENT_TIME_UNITS = {
  [RESPONSE_TIME_FILTER_UNITS.MINUTES]: 'minutes',
  [RESPONSE_TIME_FILTER_UNITS.HOURS]: 'hours',
  [RESPONSE_TIME_FILTER_UNITS.DAYS]: 'days',
};

export const MCS_FILTER_TYPES = {
  ALL: 'minutes',
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
  CUSTOM: 'custom',
};

export const CSAT_RANGE_VALUES = {
  MIN: 1,
  MAX: 5,
};

export const AGENT_SURVEY_SEARCH_TYPES = {
  NAME: 'name',
  ID: 'id',
};

export const POST_SURVEY_SEARCH_TYPES = {
  NAME: 'name',
  ID: 'id',
};

export const NPS_RANGE_VALUES = {
  MIN: 0,
  MAX: 10,
};

export const MCS_RANGE_VALUES = {
  MIN: -100,
  MAX: 100,
};

export const UNASSIGNED_SKILL_ID = -1;

export const LINE_BREAK_STRING = '\n';

/**
 * Incomplete client features list
 * @type {{PHOTO_SHARING: string, FILE_SHARING: string, MARKDOWN_HYPERLINKS: string}}
 */
export const CLIENT_FEATURES = {
  FILE_SHARING: 'FILE_SHARING',
  PHOTO_SHARING: 'PHOTO_SHARING',
  MARKDOWN_HYPERLINKS: 'MARKDOWN_HYPERLINKS',
};

/**
 * Incomplete integrations list
 * @type {{MOBILE_SDK: string}}
 */
export const INTEGRATIONS = {
  MOBILE_SDK: 'MOBILE_SDK',
};

/**
 * These are file types supported by file sharing functionality
 * @type {{OTHER: string, IMAGE: string, FILE: string, AUDIO: string}}
 */
export const FILE_TYPES = {
  AUDIO: 'AUDIO' /* All audio files, that can be played in our player */,
  IMAGE: 'IMAGE' /* Image files, that can be displayed as image in preview */,
  FILE: 'FILE' /* Files, that have no preview such as DOC, PDF */,
};

export const FILE_SHARING_SETTINGS = {
  MINIMUM_IMAGE_PREVIEW_SIZE: 800,
  MAX_RETRY_COUNT: 2,
  IMAGE_FILE_TYPES: ['PNG', 'JPG', 'GIF', 'JPEG'],
  ADDITIONAL_FILE_TYPES: ['PDF', 'DOC', 'DOCX', 'XLS', 'XLSX', 'PPT', 'PPTX'],
  MAX_FILE_SIZE: {
    DEFAULT: 5,
    PDF: 15,
  },
  MAX_CAPTION_LENGTH: 999,
  /*
  IMPORTANT:
  This object is used to:
  1) Create preview for listed file types
  2) Lookup for {extension}-thumbnail style.
  Make sure, that values here are consistent with _thumbnails.scss
*/
  THUMBNAILS: {
    PDF: pdfThumbnail,
    PPTX: pptxThumbnail,
    DOCX: docxThumbnail,
    XLSX: xlsxThumbnail,
    PPT: pptxThumbnail,
    DOC: docxThumbnail,
    XLS: xlsxThumbnail,
    GENERIC: genericThumbnail,
  },
  /*
  A media type (also known as a Multipurpose Internet Mail Extensions or MIME type)
  is a standard that indicates the nature and format of a document, file, or assortment of bytes.
*/
  MIME_TYPES: {
    PDF: 'application/pdf',
    PPTX: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    PPT: 'application/vnd.ms-powerpoint',
    DOC: 'application/msword',
    XLS: 'application/vnd.ms-excel',
    PNG: 'image/png',
    JPG: 'image/jpeg',
    GIF: 'image/gif',
    JPEG: 'image/jpeg',
  },
};

export const SITE_SETTINGS_CONTEXT_TYPES = {
  USER: 'USER',
};

export const MANAGERS_CONVERSATION_DRILL_DOWN = 'managersConversationDrillDown';

export const AGENT_SURVEY_STATUS_TYPES = {
  OPEN: 'open',
  SUBMITTED: 'submitted',
  DISMISSED: 'dismissed',
};

export const REGULAR_QUESTION_CATEGORIES = {
  FREE_TEXT: 'free_text',
  RADIO_BUTTON: 'radio_button',
  CHECKBOX: 'checkbox',
  DROPDOWN: 'dropdown',
  NUMBER: 'number',
  DATE: 'date',
};

export const QUESTION_DEFINITIONS = {
  REGULAR_QUESTION: 'regular_question',
  CONVERSATION_OUTCOME: 'conversation_outcome',
  CONVERSATION_TOPIC: 'conversation_topic',
  ENGAGEMENT_ATTRIBUTES: 'engagement_attributes',
};

export const AGENT_SURVEY_QUESTION_STATUS = {
  ANSWER: 'answer',
  SHOW: 'show',
};

export const MESSAGE_METADATA_TYPES = {
  BOT_RESPONSE: 'BotResponse',
  ESCALATION_SUMMARY: 'EscalationSummary',
  PREDEFINED_RESPONSE: 'PredefinedResponse',
  MESSAGE_REPLY_CONTEXT: 'MessageReplyContext',
  PAYMENT_REQUEST: 'PaymentRequest',
  PAYMENT_RESPONSE: 'PaymentResponse',
  SOCIAL_MESSAGING_EVENT_DATA: 'SocialMessagingEventData',
  SOCIAL_MESSAGING_CONVERSATION_DATA: 'SocialMessagingConversationData',
};

export const MESSAGE_METADATA_PAYMENT_TYPES = {
  MAVEN_PAY: 'MavenPay',
  APPLE_PAY: 'ApplePay',
};

export const MESSAGE_METADATA_PAYMENT_TRANSACTION_STATUS = {
  SUCCESS: 'success',
  FAILED: 'failure_general',
  FAILED_ACTION_REQUIRED: 'failure_actionrequired',
  TIMED_OUT: 'expired',
};

export const ANNOTATIONS_STATES = {
  OPEN: 'OPEN',
  SUBMITTED: 'SUBMITTED',
  // VETTED: 'VETTED',
};

export const ANNOTATIONS_SUBMIT_STATUSES = {
  ANNOTATED: 'ANNOTATED',
  NOT_ANNOTATED: 'NOT_ANNOTATED',
};

export const ANNOTATIONS_FILTER_TYPES = {
  CONVERSATION: 'CONVERSATION',
  INTENT: 'INTENT',
  DOMAIN: 'DOMAIN',
  STATE: 'STATE',
};

export const RFL_ERROR_STATUSES = {
  NOT_VALID_PARAM: 400,
  UN_AUTHORIZE: 403,
  ANNOTATION_NOT_EXIST: 404,
  ANNOTATION_MISSING: 405,
  ALREADY_SUBMITTED: 409,
};

export const RFL_ERROR_CODES = {
  NOT_VALID_PARAM: 11,
  UN_AUTHORIZE: 14,
  ANNOTATION_NOT_EXIST: 10,
  ALREADY_SUBMITTED: 22,
};

export const CB_TIMEOUT_ERROR_CODE = 440;

export const ANNOTATIONS_EXPORT_LIMIT = 5000;

export const NAMESPACE = {
  NEW_AGENT_WORKSPACE: 'NewAgentWorkspace',
};

export const AGENT_SURVEY_DEFAULT_MAX_CHARACTERS = 1024;

export const PRIVATE_MESSAGE_MAX_CHARACTERS = 999;

export const PREDEFINED_CONTENT_ITEMS_SHOW_PER_CATEGORY_ON_FILTER = 100;

export const FACEBOOK_CONSUMER_MENTION_REGEX = /@\[\d+\]/g;

export const CONSUMER_SUB_CHECK_REGEX = /^[\S]+_[\S]{0,3}[-]?[\d]+_[\d]+$/g;

export const CONSUMER_SUB_ID_INDEX = 2;
/**
 * @readonly
 * @enum {string}
 */
export const SOCIAL_MESSAGING_CHANNELS = {
  PRIVATE: 'Private',
  PUBLIC: 'Public',
};

/**
 * @readonly
 * @enum {string}
 */
export const SOCIAL_MESSAGING_MESSAGE_METADATA_EVENT_SOURCE = {
  FACEBOOK: 'Facebook',
  TWITTER: 'Twitter',
};

/**
 * @readonly
 * @enum {string}
 */
export const SOCIAL_MESSAGING_MESSAGE_METADATA_EVENT_TYPES = {
  DIRECT_MESSAGE: 'DirectMessage',
  FACEBOOK_POST: 'Post',
  FACEBOOK_COMMENT_ON_POST: 'CP',
  FACEBOOK_COMMENT_ON_COMMENT: 'CC',
  TWITTER_TWEET: 'Tweet',
  TWITTER_REPLY: 'Reply',
  TWITTER_RETWEET: 'Retweet',
};

export const SOCIAL_MESSAGING_DIRECT_MESSAGE_LINKS = {
  [SOCIAL_MESSAGING_MESSAGE_METADATA_EVENT_SOURCE.FACEBOOK]: 'https://m.me/',
  [SOCIAL_MESSAGING_MESSAGE_METADATA_EVENT_SOURCE.TWITTER]: 'https://twitter.com/messages/compose?recipient_id=',
};

export const SOCIAL_MESSAGING_FACEBOOK_URL = 'https://www.facebook.com/';

export const SOCIAL_MESSAGING_FACEBOOK_POSTS_URL = '/posts/';

export const SOCIAL_MESSAGING_TWITTER_URL = 'https://www.twitter.com/';

export const SOCIAL_MESSAGING_TWITTER_WIDGET_URL = 'https://platform.twitter.com/widgets.js';

export const SOCIAL_MESSAGING_RICH_CONTENT_FLAG = 'sm-piggyback';
